import { omit } from "../../../../../utils/omit";
export const prepareFieldsForAV = (registerObject, formValue, additionalFields) => {
    if (registerObject === null || registerObject === void 0 ? void 0 : registerObject.custom_attributes) {
        const customAttrsForAv = {};
        additionalFields === null || additionalFields === void 0 ? void 0 : additionalFields.data.map((field) => {
            var _a, _b, _c;
            if (field.type === "address") {
                (customAttrsForAv.custom_address_street_name = (_a = formValue === null || formValue === void 0 ? void 0 : formValue.streetName) !== null && _a !== void 0 ? _a : ""),
                    (customAttrsForAv.custom_address_street_number = (_b = formValue === null || formValue === void 0 ? void 0 : formValue.streetNumber) !== null && _b !== void 0 ? _b : ""),
                    (customAttrsForAv.custom_address_apartment = (_c = formValue === null || formValue === void 0 ? void 0 : formValue.streetAdditional) !== null && _c !== void 0 ? _c : "");
            }
            else {
                customAttrsForAv["custom_" + field.code] = (formValue === null || formValue === void 0 ? void 0 : formValue.custom_attributes[field.code]) || "";
            }
        });
        const avObject = Object.assign({ firstname: registerObject.firstname, lastname: registerObject.lastname, date_of_birth: registerObject.date_of_birth, phone: registerObject.phone }, customAttrsForAv);
        return omit(avObject, "password");
    }
    return {};
};
